export default __webpack_public_path__ + "static/media/5 icon (1).892fab0d.jpg";